import './WhyUs.css';

function WhyUs() {
    return (
        <div className="Container-WhyUs">

            {/*<div className="Container-WhyUs-left">*/}
            {/*    <h1>Why Choose Falcon XXL?</h1>*/}
            {/*</div>*/}

            <div className="Container-WhyUs-right">

                {/* Bloc 1 */}
                <div className="Container-WhyUs-right-content">
                    <div className="Container-WhyUs-right-title"
                    style={{color:"white"}}>
                        Typical uses:
                    </div>
                    <div className="Container-WhyUs-right-paragraf">
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                Advertising campaigns
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                Youtube videos
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                Social media posts
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                Business presentations
                            </p>
                        </div>
                    </div>
                </div>

                {/* Bloc 1 */}
                {/*<div className="Container-WhyUs-right-content">*/}
                {/*    <div className="Container-WhyUs-right-title">*/}
                {/*        Webdesign*/}
                {/*    </div>*/}
                {/*    <div className="Container-WhyUs-right-paragraf">*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                We build secure websites, protect business, and earn clients’ trust.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                Your website grows with new features, pages, and updates.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                We work with you to build a site that fits your real needs.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                Optimized the ground up to rank on Google and attract qualified visitors.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/* Bloc 1 */}
                {/*<div className="Container-WhyUs-right-content">*/}
                {/*    <div className="Container-WhyUs-right-title">*/}
                {/*        Branding*/}
                {/*    </div>*/}
                {/*    <div className="Container-WhyUs-right-paragraf">*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                we help clients define their brand and build a clear, coherent image.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                we create logos, colors, typography, and visuals that stand out.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                We produce flyers, business cards, brochures, and other promotional items.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                We ensure all elements, digital or physical, tell a uniform and professional story.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/* Bloc 2 */}
                {/*<div className="Container-WhyUs-right-content-x">*/}
                {/*    <div className="Container-WhyUs-right-title">*/}
                {/*        Music*/}
                {/*    </div>*/}
                {/*    <div className="Container-WhyUs-right-paragraf">*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                We create music tailored to our clients’ ideas.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                our experienced team works with high-quality gear to ensure*/}
                {/*                the best possible output.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                We analyze trends and references to offer relevant and tailored music.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*        <div className="icon-text">*/}
                {/*            <i className="fa-solid fa-circle-check"></i>*/}
                {/*            <p>*/}
                {/*                We take client feedback into account at every stage to refine and*/}
                {/*                perfect the final result.*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

            </div>

        </div>
    );
}

export default WhyUs;
